import { axiosInstance,axiosRequestWithAuth } from './../constants/server.constant';
export const MetricsService = {
    getDataByType
}

function getUserId() {
    return localStorage.getItem('userId');
}
 
function transformBandwidthData(apiData){

    let newCombinedBandwidthData ;
    let minLength  ;
    let len1 = 99999;
    let len2 = 99999;
    let d1 = [] ;
    let d1Name = "DNE" ;
    let d2 = [] ;
    let d2Name = "DNE" ;
    let d3 = [] ;
    let d3Name = "DNE" ;
    let d4 = [] ;
    let d4Name = "DNE" ;

    let publicNetwork = apiData["public_interface"]

    if(publicNetwork && (Object.entries(publicNetwork).length)){
        let publicIncoming = publicNetwork["bytes_incoming"] ;
        let publicOutgoing = publicNetwork["bytes_outgoing"] ;
        if((publicIncoming && (Object.entries(publicIncoming).length)) && !(publicOutgoing && (Object.entries(publicOutgoing).length))){
            d1 = publicIncoming ;
            d1Name = "Public In" ;  
            len1 = publicIncoming.length ;       
        }
        if(!(publicIncoming && (Object.entries(publicIncoming).length)) && (publicOutgoing && (Object.entries(publicOutgoing).length))){
            d1 = publicOutgoing ;
            d1Name = "Public Out" ;
            len1 = publicOutgoing.length ;
        }
        if((publicIncoming && (Object.entries(publicIncoming).length)) && (publicOutgoing && (Object.entries(publicOutgoing).length))){
            d1 = publicIncoming ;
            d1Name = "Public In" ;
            d3 = publicOutgoing ;
            d3Name = "Public Out" ;  
            len1 = Math.min(publicIncoming.length, publicOutgoing.length) ;       
        }
    }

    let privateNetwork  = apiData["private_interface"] ;
    if( privateNetwork && (Object.entries(privateNetwork).length) ){
        let privateIncoming = privateNetwork["bytes_incoming"] ;
        let privateOutgoing = privateNetwork["bytes_outgoing"] ;
        if((privateIncoming && (Object.entries(privateIncoming).length)) && !(privateOutgoing && (Object.entries(privateOutgoing).length))){
            d2 = privateIncoming ;
            d2Name = "Private In" ;
            len2 = privateIncoming.length ;
        }
        if(!(privateIncoming && (Object.entries(privateIncoming).length)) && (privateOutgoing && (Object.entries(privateOutgoing).length))){
            d2 = privateOutgoing ;
            d2Name = "Private Out" ;
            len2 = privateOutgoing.length ;
        }
        if((privateIncoming && (Object.entries(privateIncoming).length)) && (privateOutgoing && (Object.entries(privateOutgoing).length))){
            d2 = privateIncoming ;
            d2Name = "Private In" ;
            d4 = privateOutgoing ;
            d4Name = "Private Out" ;
            len2 = Math.min(privateIncoming.length, privateOutgoing.length) ;
        }
    }

    minLength = Math.min(len1, len2 ) ;
    newCombinedBandwidthData = transformData(minLength, d1, d1Name, d2, d2Name, d3, d3Name, d4, d4Name) ;

    return newCombinedBandwidthData ;
}


function transformCpuData(apiData){
     
    let newCpuData = transformData(apiData.length, apiData, "CPU %") ;
    return newCpuData ;
   
}

function transformDiskData(apiData){

    let newCombinedDiskData ;
    let minLength ;
    let d1 = [] ;
    let d1Name = "DNE" ;
    let d2 = [] ;
    let d2Name = "DNE" ;
    let read = apiData["read_bytes"] ;
    let write = apiData["write_bytes"] ;
    
    
    if((read && (Object.entries(read).length)) && !(write && (Object.entries(write).length)) ){
        d1 = read ;
        d1Name = "read" ;
        minLength = read.length ;
    }
    if(!(read && (Object.entries(read).length)) && (write && (Object.entries(write).length))){
        d1 = write ;
        d1Name = "write" ;
        minLength = write.length ;
    }
    if((read && (Object.entries(read).length)) && (write && (Object.entries(write).length))){
        d1 = read ;
        d1Name = "read" ;
        d2 = write ;
        d2Name = "write" ;
        minLength = Math.min(read.length, write.length) ;
    }
    
    newCombinedDiskData = transformData(minLength, d1, d1Name, d2, d2Name) ;

    return newCombinedDiskData ;
}

function filterDataByStartAndEndDate(data, startDate, endDate) {
    let filtData = data.filter(function(item){
        let date =  item[0];
        return date >=startDate  && date <= endDate;
    });
    return filtData;                 
}

function minElementOfFour(a, b, c, d){
    let minElId = 1 ;
    let minEl = a ;
    if(b < a){
        minElId = 2 ;
        minEl = b ;
    }
    if(c < minEl){
        minElId = 3 ;
        minEl = c ;
    }
    if(d < minEl){
        minElId = 4 ;
        minEl = d ;
    }

    return minElId ;
}

function transformData(rows, data1, data1Type, data2=[], data2Type='DNE', data3=[], data3Type='DNE', data4=[], data4Type='DNE', step = 1){

    if(data1.length !== 0 && data2.length === 0 && data3.length === 0 && data4.length === 0 ){
        let  columns = data1[0].length ;
        let transformedArray = [] ;
        for(let i=step; i<=rows-step; i++){
            let obj = {} ;
            var DateEl  = new Date(data1[i][0]) ;
            obj["Date"] = DateEl ;
            var valEl1  = (data1[i][columns-1] < data1[i-step][columns-1]) ? data1[i][columns-1] : (data1[i][columns-1] - data1[i-step][columns-1])  ;           
            if(data1Type === "CPU %"){
                valEl1 = (valEl1/(1000000000 * 5 * 60))*100 ;            
            }
            obj[data1Type] = valEl1 ;
            transformedArray.push(obj) ;
        }
        return transformedArray ;     
    }

    if(data1.length === 0 && data2.length !== 0 && data3.length === 0 && data4.length === 0 ){
        let  columns = data2[0].length ;
        let transformedArray = [] ;
        for(let i=step; i<=rows-step; i++){
            let obj = {} ;
            var DateEl  = new Date(data2[i][0]) ;
            obj["Date"] = DateEl ;
            var valEl2  = (data2[i][columns-1] < data2[i-step][columns-1]) ? data2[i][columns-1] : (data2[i][columns-1] - data2[i-step][columns-1])  ;          
            obj[data2Type] = valEl2 ;
            transformedArray.push(obj) ;
        }
        return transformedArray ;    
    }
    if(data1.length !== 0 && data2.length !== 0 && data3.length === 0 && data4.length === 0 ){       
        let len1 = data1.length ;
        let len2 = data2.length ;  
        //let minData ;
        let minStartDate ;
        let minEndDate ;  
        if(len1 < len2){
            //minData = data1 ;
            minStartDate = data1[0][0] ;
            minEndDate = data1[len1-1][0] ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
        }
        if(len1 > len2){        
            //minData = data2 ;
            minStartDate = data2[0][0] ;
            minEndDate = data2[len2-1][0] ; 
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
        }
        let  columns = data1[0].length ;
        let transformedArray = [] ;
        for(let i=step; i<=rows-step; i++){
            let obj = {} ;
            var DateEl  = new Date(data1[i][0]) ;
            obj["Date"] = DateEl ;
            var valEl1  = (data1[i][columns-1] < data1[i-step][columns-1]) ? data1[i][columns-1] : (data1[i][columns-1] - data1[i-step][columns-1])  ;
            var valEl2  = (data2[i][columns-1] < data2[i-step][columns-1]) ? data2[i][columns-1] : (data2[i][columns-1] - data2[i-step][columns-1])  ; 
            obj[data1Type] = valEl1 ;           
            obj[data2Type] = valEl2 ;
            transformedArray.push(obj) ;            
        }
        return transformedArray ;  
    }
    if(data1.length !== 0 && data2.length === 0 && data3.length !== 0 && data4.length === 0 ){
        let len1 = data1.length ;
        let len3 = data3.length ;
        //let minData ;
        let minStartDate ;
        let minEndDate ;  
        if(len1 < len3){
            //minData = data1 ;
            minStartDate = data1[0][0] ;
            minEndDate = data1[len1-1][0] ;
            data3 = filterDataByStartAndEndDate(data3, minStartDate, minEndDate) ;
        }
        if(len1 > len3){
            //minData = data2 ;
            minStartDate = data3[0][0] ;
            minEndDate = data3[len3-1][0] ;
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
        }
        let  columns = data1[0].length ;
        let transformedArray = [] ;
        for(let i=step; i<=rows-step; i++){
            let obj = {} ;
            var DateEl  = new Date(data1[i][0]) ;
            obj["Date"] = DateEl ;
            var valEl1  = (data1[i][columns-1] < data1[i-step][columns-1]) ? data1[i][columns-1] : (data1[i][columns-1] - data1[i-step][columns-1])  ;
            var valEl3  = (data3[i][columns-1] < data3[i-step][columns-1]) ? data3[i][columns-1] : (data3[i][columns-1] - data3[i-step][columns-1])  ;
            obj[data1Type] = valEl1 ;           
            obj[data3Type] = valEl3 ;
            transformedArray.push(obj) ;            
        }
        return transformedArray ;  
    }
    if(data1.length !== 0 && data2.length !== 0 && data3.length !== 0 && data4.length === 0 ){
        let len1 = data1.length ;
        let len2 = data2.length ;
        let len3 = data3.length ;
        //let minData ;
        let minStartDate ;
        let minEndDate ;  
        if(len1 < len2 && len1 < len3){
            //minData = data1 ;
            minStartDate = data1[0][0] ;
            minEndDate = data1[len1-1][0] ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
            data3 = filterDataByStartAndEndDate(data3, minStartDate, minEndDate) ;
        }
        if(len2 < len1 && len2 < len3){
            //minData = data2 ;
            minStartDate = data2[0][0] ;
            minEndDate = data2[len2-1][0] ;
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
            data3 = filterDataByStartAndEndDate(data3, minStartDate, minEndDate) ;
        }
        if(len3 < len1 && len3 < len2){
            //minData = data3 ;
            minStartDate = data3[0][0] ;
            minEndDate = data3[len3-1][0] ;
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
        }
        let  columns = data1[0].length ;
        let transformedArray = [] ;
        for(let i=step; i<=rows-step; i++){
            let obj = {} ;
            var DateEl  = new Date(data1[i][0]) ;
            obj["Date"] = DateEl ;
            var valEl1  = (data1[i][columns-1] < data1[i-step][columns-1]) ? data1[i][columns-1] : (data1[i][columns-1] - data1[i-step][columns-1])  ;
            var valEl2  = (data2[i][columns-1] < data2[i-step][columns-1]) ? data2[i][columns-1] : (data2[i][columns-1] - data2[i-step][columns-1])  ; 
            var valEl3  = (data3[i][columns-1] < data3[i-step][columns-1]) ? data3[i][columns-1] : (data3[i][columns-1] - data3[i-step][columns-1])  ;
            obj[data1Type] = valEl1 ;   
            obj[data2Type] = valEl2 ;        
            obj[data3Type] = valEl3 ;
            transformedArray.push(obj) ;            
        }
        return transformedArray ;  
    }
    if(data1.length !== 0 && data2.length !== 0 && data3.length === 0 && data4.length !== 0 ){
        let len1 = data1.length ;
        let len2 = data2.length ;
        let len4 = data4.length ;
        //let minData ;
        let minStartDate ;
        let minEndDate ;  
        if(len1 < len2 && len1 < len4){
            //minData = data1 ;
            minStartDate = data1[0][0] ;
            minEndDate = data1[len1-1][0] ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
            data4 = filterDataByStartAndEndDate(data4, minStartDate, minEndDate) ;
        }
        if(len2 < len1 && len2 < len4){
            //minData = data2 ;
            minStartDate = data2[0][0] ;
            minEndDate = data2[len2-1][0] ;
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
            data4 = filterDataByStartAndEndDate(data4, minStartDate, minEndDate) ;
        }
        if(len4 < len1 && len4 < len2){
            //minData = data4 ;
            minStartDate = data4[0][0] ;
            minEndDate = data4[len4-1][0] ;
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
        }
        let  columns = data1[0].length ;
        let transformedArray = [] ;
        for(let i=step; i<=rows-step; i++){
            let obj = {} ;
            var DateEl  = new Date(data1[i][0]) ;
            obj["Date"] = DateEl ;
            var valEl1  = (data1[i][columns-1] < data1[i-step][columns-1]) ? data1[i][columns-1] : (data1[i][columns-1] - data1[i-step][columns-1])  ;
            var valEl2  = (data2[i][columns-1] < data2[i-step][columns-1]) ? data2[i][columns-1] : (data2[i][columns-1] - data2[i-step][columns-1])  ; 
            var valEl4  = (data4[i][columns-1] < data4[i-step][columns-1] ) ? data4[i][columns-1] : (data4[i][columns-1] - data4[i-step][columns-1])  ; 
            obj[data1Type] = valEl1 ;           
            obj[data2Type] = valEl2 ;
            obj[data4Type] = valEl4 ;
            transformedArray.push(obj) ;            
        }
        return transformedArray ;  
    }
    if(data1.length === 0 && data2.length !== 0 && data3.length === 0 && data4.length !== 0 ){
        let len2 = data2.length ;
        let len4 = data4.length ;
        //let minData ;
        let minStartDate ;
        let minEndDate ;  
        if(len2 < len4){
            //minData = data2 ;
            minStartDate = data2[0][0] ;
            minEndDate = data2[len2-1][0] ;
            data4 = filterDataByStartAndEndDate(data4, minStartDate, minEndDate) ;
        }
        if(len2 > len4){
            //minData = data2 ;
            minStartDate = data4[0][0] ;
            minEndDate = data4[len4-1][0] ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
        }
        let  columns = data2[0].length ;
        let transformedArray = [] ;
        for(let i=step; i<=rows-step; i++){
            let obj = {} ;
            var DateEl  = new Date(data2[i][0]) ;
            obj["Date"] = DateEl ;
            var valEl2  = (data2[i][columns-1] < data2[i-step][columns-1]) ? data2[i][columns-1] : (data2[i][columns-1] - data2[i-step][columns-1])  ; 
            var valEl4  = (data4[i][columns-1] < data4[i-step][columns-1] ) ? data4[i][columns-1] : (data4[i][columns-1] - data4[i-step][columns-1])  ; 
            obj[data2Type] = valEl2 ;           
            obj[data4Type] = valEl4 ;
            transformedArray.push(obj) ;            
        }
        return transformedArray ;  
            
    }
    if(data1.length !== 0 && data2.length !== 0 && data3.length !== 0 && data4.length !== 0 ){
        let len1 = data1.length ;
        let len2 = data2.length ;
        let len3 = data3.length ;
        let len4 = data4.length ;
        let minDataId 
        if(!(len1 === len2 && len2===len3 && len3===len4)){
            minDataId = minElementOfFour(len1, len2, len3, len4) ;
        }
        //let minData ;
        let minStartDate ;
        let minEndDate ; 
        if(minDataId === 1){
            minStartDate = data1[0][0] ;
            minEndDate = data1[len1-1][0] ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
            data3 = filterDataByStartAndEndDate(data3, minStartDate, minEndDate) ;
            data4 = filterDataByStartAndEndDate(data4, minStartDate, minEndDate) ;
        }
        if(minDataId === 2){
            minStartDate = data2[0][0] ;
            minEndDate = data2[len2-1][0] ;
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
            data3 = filterDataByStartAndEndDate(data3, minStartDate, minEndDate) ;
            data4 = filterDataByStartAndEndDate(data4, minStartDate, minEndDate) ;
        }
        if(minDataId === 3){
            minStartDate = data3[0][0] ;
            minEndDate = data3[len3-1][0] ;
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
            data4 = filterDataByStartAndEndDate(data4, minStartDate, minEndDate) ;
        }
        if(minDataId === 4){
            minStartDate = data4[0][0] ;
            minEndDate = data4[len4-1][0] ;
            data1 = filterDataByStartAndEndDate(data1, minStartDate, minEndDate) ;
            data2 = filterDataByStartAndEndDate(data2, minStartDate, minEndDate) ;
            data3 = filterDataByStartAndEndDate(data3, minStartDate, minEndDate) ;
        }

        let  columns = data1[0].length ;
        let transformedArray = [] ;
        for(let i=step; i<=rows-step; i++){
            let obj = {} ;
            var DateEl  = new Date(data1[i][0]) ;
            obj["Date"] = DateEl ;
            var valEl1  = (data1[i][columns-1] < data1[i-step][columns-1]) ? data1[i][columns-1] : (data1[i][columns-1] - data1[i-step][columns-1])  ;
            var valEl2  = (data2[i][columns-1] < data2[i-step][columns-1]) ? data2[i][columns-1] : (data2[i][columns-1] - data2[i-step][columns-1])  ; 
            var valEl3  = (data3[i][columns-1] < data3[i-step][columns-1]) ? data3[i][columns-1] : (data3[i][columns-1] - data3[i-step][columns-1])  ;
            var valEl4  = (data4[i][columns-1] < data4[i-step][columns-1] ) ? data4[i][columns-1] : (data4[i][columns-1] - data4[i-step][columns-1])  ; 
            obj[data1Type] = valEl1 ;           
            obj[data2Type] = valEl2 ;
            obj[data3Type] = valEl3 ;
            obj[data4Type] = valEl4 ;
            transformedArray.push(obj) ;            
        }
        return transformedArray ; 
    }
}

async function getDataByType(type, instanceId,startDate,regionName) {
    return await axiosInstance.get('/metrics/' + getUserId() + '/' + instanceId + '/' + type+'?startDate='+startDate+'&regionName='+regionName, axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            //console.log(data)
            let newData = [];
            if(data === null || data.length == 0){
               // console.log(data)
                return newData ;
            }
            else{
                if(type === 'bandwidth'){
                    if((!data.private_interface || (!data.private_interface.bytes_incoming.length && !data.private_interface.bytes_outgoing.length)) && (!data.public_interface || (!data.public_interface.bytes_incoming.length && !data.public_interface.bytes_outgoing.length))){
                        return newData ;
                    }
                    newData = transformBandwidthData(data) ;
                }
                if(type === 'cpu'){
                    newData = transformCpuData(data) ;
                }
                if(type === 'diskio'){
                    if((!data.read_bytes || !data.read_bytes.length) && (!data.write_bytes || !data.write_bytes.length)){
                        return newData ;
                    }
                    newData = transformDiskData(data) ;
                }
                //console.log(newData)
                return newData;
            }            
        }).catch(function (error) {
            return []
        });
}

export default MetricsService;